import { loadStripe } from '@stripe/stripe-js';
import { USER_LIMITS, UserRole } from './types';

// Initialize Stripe with public key
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY || '');

// Get plan configuration by role
export const getPlanConfig = (role: UserRole) => {
  return USER_LIMITS[role];
};

// Initialize payment for a specific plan
export const initiatePayment = async (planRole: UserRole, priceId: string) => {
  try {
    const stripe = await stripePromise;
    if (!stripe) throw new Error('Stripe n\'a pas pu être initialisé');

    const planConfig = getPlanConfig(planRole);
    if (!planConfig) {
      throw new Error('Configuration du plan invalide');
    }

    console.log('Initiating payment for plan:', planRole);
    console.log('Plan config:', planConfig);
    console.log('Price ID:', priceId);

    // Create a checkout session directly with Stripe
    const { error } = await stripe.redirectToCheckout({
      lineItems: [{
        price: priceId,
        quantity: 1,
      }],
      mode: 'subscription',
      successUrl: `${window.location.origin}/subscription/success`,
      cancelUrl: `${window.location.origin}/subscription/cancel`,
    });

    if (error) {
      console.error('Stripe checkout error:', error);
      throw error;
    }
  } catch (error) {
    console.error('Erreur lors de l\'initiation du paiement:', error);
    throw error;
  }
};

// Verify subscription status
export const verifySubscription = async (subscriptionId: string) => {
  try {
    const response = await fetch(`/api/verify-subscription/${subscriptionId}`);
    return await response.json();
  } catch (error) {
    console.error('Erreur lors de la vérification de l\'abonnement:', error);
    throw error;
  }
};

// Cancel subscription
export const cancelSubscription = async (subscriptionId: string) => {
  try {
    const response = await fetch(`/api/cancel-subscription/${subscriptionId}`, {
      method: 'POST',
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur lors de l\'annulation de l\'abonnement:', error);
    throw error;
  }
};